  export const events = [{
      id: 'erster-fall',
      date: '17.11.2019',
      text: 'Der erste bekannte Covid-19-Patient steckte sich am 17. November in der zentralchinesischen Stadt Wuhan an. ',
      link: 'https://www.faz.net/aktuell/politik/ausland/coronavirus-in-wuhan-die-geschichte-eines-scheiterns-16691212.html',
    },
    {
      id: 'behoerden-info',
      date: '27.12.2019',
      text: 'Die lokale Gesundheitsbehörde war spätestens am 27. Dezember über den Befund eines SARS-ähnlichen Erregers informiert. ',
      link: 'https://www.faz.net/aktuell/politik/ausland/coronavirus-in-wuhan-die-geschichte-eines-scheiterns-16691212.html',
    },
    {
      id: 'china-ueber-10k',
      date: '31.01.2020',
      text: 'In China haben sich über 10.000 Personen mit dem Corona-virus angesteckte.',
      link: 'https://www.worldometers.info/coronavirus/country/china/',
    },
    {
      id: 'erste-fall',
      date: '28.01.2020',
      text: 'Der erste Infektionsfall in Deutschland wurde bei einem 33-jährigen Mitarbeiter des Automobilzulieferers Webasto in Stockdorf festgestellt.',
      link: 'https://www.zeit.de/wissen/gesundheit/2020-01/coronavirus-china-infektionen-ausbreitung-liveblog',
    },
    {
      id: 'china-hoester-wert',
      date: '13.02.2020',
      text: 'China verzeichnet an diesem Tag 15.141 Neusansteckungen.',
      link: 'https://data.europa.eu/euodp/de/data/dataset/covid-19-coronavirus-data/resource/260bbbde-2316-40eb-aec3-7cd7bfc2f590',
    },
    {
      id: 'erste-tode',
      date: '09.03.2020',
      text: 'Erste zwei Todesfälle in Deutschland',
      link: 'https://www.n-tv.de/panorama/Wer-waren-die-beiden-Corona-Toten-article21629822.html',
    },
    {
      id: 'ansprache-kanzlerin',
      date: '19.03.2020',
      text: 'Ansprache der Kanzlerin: "Dies ist eine historische Aufgabe - und sie ist nur gemeinsam zu bewältigen"',
      link: 'https://www.bundesregierung.de/breg-de/themen/coronavirus/ansprache-der-kanzlerin-1732108',
    },
    {
      id: 'erste-lockerungen',
      date: '20.04.2020',
      text: 'In Deutschland treten die ersten vorsichtigen Lockerungen der Corona-Schutzmaßnahmen in Kraft. Viele Bundesländer erlauben wieder das Einkaufen in Geschäften bis zu einer Größe von 800 Quadratmetern.',
      link: 'https://www.mdr.de/nachrichten/politik/corona-chronik-chronologie-coronavirus-100.html',
    },
  ];